<template>
  <div>
    <vue-portal to="hrsys-navbar-actions">
      <vx-tooltip :text="$t('buttons.create')" class="ml-2" position="bottom">
        <base-button @click="openCreationForm" class="self-end" icon="plus"/>
      </vx-tooltip>
    </vue-portal>
    <pto-details-modal :action="action"
                       :loadingActions="loadingModalActions"
                       :popup-active="!!action"
                       :pto-data="selectedPto"
                       @cancel="clearSelection"
                       @create="createPto"
                       @send="actionAndSendPtoRequest"
                       @update="updatePto"/>
    <base-loader :loading="loading">
      <div class="rounded-lg shadow-md">
        <ptos-personal-table
          :header="tableHeader"
          :ptos="list"
          :updatingPtos="updatingPtos"
          @delete="deletePto"
          @details="openDetails"
          @request="sendPtoRequest"/>
        <pagination :pagination="pagination" @input="changePage" v-if="pagination.total"/>
      </div>
    </base-loader>
  </div>

</template>

<script>
  import PtosPersonalTable from "../../components/ptos/PtosPersonalTable";
  import PtoDetailsModal from "../../components/ptos/PtoDetailsModal";
  import Pagination from "../../components/Pagination";
  import Ptos from "../../services/Ptos";
  import EventBus from "../../utilities/eventBus";

  export default {
    name: "PersonalPTOs",
    components: {
      PtosPersonalTable,
      PtoDetailsModal,
      Pagination
    },
    data: () => ({
      loading: false,
      list: [],
      pagination: {},
      queryParams: {
        page: 1,
      },
      updatingPtos: [],
      action: null,
      selectedPto: {},
      loadingModalActions: false,
    }),
    methods: {
      getMyPtos () {
        this.loading = true;
        Ptos.myPtos().then(res => {
          this.list = res.data
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loading = false;
        })
      },
      openDetails (pto) {
        this.selectedPto = pto
        if (pto.status === 'DRAFT') {
          this.action = 'update'
        } else {
          EventBus.$emit('ptoDetails', pto)
        }
      },
      openCreationForm () {
        this.action = 'create'
      },
      updatePto () {
        let freshPto = {
          id: this.selectedPto.id,
          start_date: this.selectedPto.start_date,
          end_date: this.selectedPto.end_date,
          notes: this.selectedPto.notes
        }
        this.loadingModalActions = true
        Ptos.update(freshPto).then(() => {
          this.getMyPtos()
          this.clearSelection()
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successCreate')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingModalActions = false
        })
      },
      createPto () {
        this.loadingModalActions = true
        Ptos.create(this.selectedPto).then(() => {
          this.getMyPtos()
          this.clearSelection()
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successCreate')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingModalActions = false
        })
      },
      sendPtoRequest (pto) {
        Ptos.request(pto.id).then(() => {
          this.list[this.getPtoIndex(pto.id)].status = 'PENDING';
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successRequest')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.updatingPtos.splice(this.updatingPtos.indexOf(pto.id))
        })
      },
      actionAndSendPtoRequest () {
        this.loadingModalActions = true
        Ptos[this.action](this.selectedPto).then((res) => {
          Ptos.request(res.data.id).then(() => {
            this.getMyPtos()
            this.clearSelection()
            this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successRequest')}`)
          }).catch(error => {
            this.$notificationService.error(error.message)
          }).finally(() => {
            this.loadingModalActions = false
          })
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.loadingModalActions = false
        })
      },
      deletePto (pto) {
        Ptos.delete(pto.id).then(() => {
          this.list.splice(this.getPtoIndex(pto.id), 1).join('');
          // this.getMyPtos()
          this.$notificationService.success(`${this.$t('ptos.pto')} ${this.$t('notification.successDelete')}`)
        }).catch(error => {
          this.$notificationService.error(error.message)
        }).finally(() => {
          this.updatingPtos.splice(this.updatingPtos.indexOf(pto.id))
        })
      },
      search () {
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.queryParams.page = 1;
        this.getMyPtos()
      },
      getUrlParams () {
        let vm = this;
        if (this.$route.query.page) {
          vm.queryParams = Object.assign({}, vm.$route.query);
        }
      },
      changePage (newPage) {
        this.queryParams.page = newPage;
        this.$router.push({query: this.queryParams}).catch(() => {
        })
        this.getClients()
      },
      getPtoIndex (id) {
        return this.list.findIndex((pto) => pto.id === id)
      },
      clearSelection () {
        this.loadingModalActions = false;
        this.action = null;
        this.selectedPto = {}
      }
    },
    computed: {
      tableHeader () {
        return ([
          this.$t('ptos.table.start_date'),
          this.$t('ptos.table.end_date'),
          this.$t('ptos.table.status'),
          this.$t('ptos.table.actions')
        ])
      }
    },
    mounted () {
      this.getUrlParams()
      this.getMyPtos()
    },
  }
</script>

<style scoped>

</style>
